import { type FC } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as uuid from 'uuid';

import { updateValidation } from '@editor2/services/elementValidationsActionsService';
import {
	type ResponseBoard,
	type SAQuestion,
	type SAQuestionValidation
} from '@editor2/types/pageElements';

interface Props {
	element: SAQuestion | ResponseBoard;
	validation: SAQuestionValidation;
	validationIndex: number;
	courseId: number;
}

export const EnableSwitch: FC<Props> = ({ element, validation, validationIndex, courseId }) => {
	const dispatch = useDispatch();

	return (
		<Form.Check
			id={uuid.v4()}
			type="switch"
			checked={validation.enabled}
			onChange={() =>
				dispatch(
					updateValidation(
						element,
						{ ...validation, enabled: !validation.enabled },
						validationIndex,
						courseId
					)
				)
			}
			label="Enabled"
			className="enableSwitch"
		/>
	);
};
